module.exports = __webpack_public_path__ + "static/img/aliyun.35887422.png";